<template>
  <div class="manage_entry_wrap">
    <div class="manage_entry_box" @click="goManage">
      <p>
        {{ $t('FoodC_subscription_QaXu_EIIa', { didipackbrand: brandName }) }}
      </p>
      <img src="@/assets/images/member/pay_arrow_right.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ManageEntry',
  props: {
    membership: {
      default: () => {},
      type: Object,
    },
  },
  computed: {
    brandName() {
      return this.membership?.brandName
    },
  },
  methods: {
    goManage() {
      this.$router?.push({
        path: '/member/managerMain',
        query: {
          nativeWebUIType: 1,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.manage_entry_wrap {
  margin: 0 20px;
}
.manage_entry_box {
  position: relative;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding: 0 40px;
  width: 100%;
  height: 128px;
  background: #ffffff;
  border-radius: 40px;
  p {
    font-family: DiDiSans-Pro-Medium;
    font-size: 32px;
    color: #0b0b0d;
    line-height: 40px;
    font-weight: 500;
  }
  img {
    position: absolute;
    right: 40px;
    width: 40px;
    height: 40px;
  }
}
</style>
